<template>
    <button @click.prevent="showModal" class="button" :class="{'blue':canAddCampaignForPlan(),'light':!canAddCampaignForPlan()}"
       :disabled="!canAddCampaignForPlan()">
        <span class="icon"><i class="mdi mdi-plus"></i></span>
        <span>Create Campaign <br> <small v-show="!canAddCampaignForPlan()">Account maximum reached</small></span>
    </button>

    <modal v-show="isModalVisible"
           @close="closeModal" :is-active="isModalVisible">
        <template v-slot:header>Create new Campaign</template>
        <template v-slot:body>
            <div class="mb-6">
                <div class="card-content">
                    <form class="md:rounded border-0 dark:bg-gray-900/70 bg-white border dark:border-0" @submit.prevent="createNewCampaign">
                        <div class="field">
                            <label class="label">Name</label>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control icons-left">
                                        <input v-model="form.name" required class="px-3 py-2 max-w-full focus:ring focus:outline-none border-gray-700 rounded w-full dark:placeholder-gray-400 h-12 border bg-white dark:bg-gray-800 pl-10" type="text"
                                               placeholder="Campaign Name">
                                        <span class="icon left"><i class="mdi mdi-newspaper-variant"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--                        <div class="field">-->
                        <!--                            <label class="label">Code</label>-->
                        <!--                            <div class="field-body">-->
                        <!--                                <div class="field">-->
                        <!--                                    <div class="control icons-left">-->
                        <input v-model="form.code" required class="px-3 py-2 max-w-full focus:ring focus:outline-none border-gray-700 rounded w-full dark:placeholder-gray-400 h-12 border bg-white dark:bg-gray-800 pl-10" type="hidden" readonly
                               placeholder="Campaign Code">
                        <!--                                        <span class="icon left"><i class="mdi mdi-barcode"></i></span>-->
                        <!--                                    </div>-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </div>-->

                        <div class="field">
                            <label class="label">Campaign Url</label>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control icons-left">
                                        <input v-model="form.url" required class="px-3 py-2 max-w-full focus:ring focus:outline-none border-gray-700 rounded w-full dark:placeholder-gray-400 h-12 border bg-white dark:bg-gray-800 pl-10" type="url"
                                               placeholder="https://">
                                        <span class="icon left"><i class="mdi mdi-link"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Expires At</label>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control icons-left">
                                        <!--                                        <input v-model="form.expires_at" class="input" type="date"-->
                                        <!--                                               placeholder="dd-mm-yyyy">-->
                                        <Datepicker v-model="form.expires_at" :clearable="false"
                                                    :minDate="new Date()" :dark="isDark"></Datepicker>
                                        <!--                                        <span class="icon left"><i class="mdi mdi-calendar"></i></span>-->
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="field">
                            <label class="label">Description (Optional)</label>
                            <div class="control">
                                <textarea v-model="form.description" class="textarea px-3 py-2 max-w-full focus:ring focus:outline-none border-gray-700 rounded w-full dark:placeholder-gray-400 border bg-white dark:bg-gray-800 pl-10"
                                          placeholder="Describe your campaign for easy identification"></textarea>
                            </div>
                        </div>

                        <div class="field grouped">
                            <div class="control">
                                <button type="submit" class="button green">
                                    Submit
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </template>
        <!--        <template v-slot:footer>-->
        <!--            <button class="button" @click="closeModal">Cancel</button>-->
        <!--            <button class="button blue" @click="createNewCampaign">Create</button>-->
        <!--        </template>-->
    </modal>
</template>

<script>
import Modal from "@/Components/Modal";
import Datepicker from 'vue3-date-time-picker';
import 'vue3-date-time-picker/dist/main.css'

export default {
    name: "NewCampaign",
    components: {Modal, Datepicker},
    data() {
        return {
            isModalVisible: false,
            form: this.$inertia.form({
                name: '',
                code: '',
                url: '',
                expires_at: this.addDaysToCurrentDate(1),
                description: ''
            }),
            isDark: window.matchMedia('(prefers-color-scheme: dark)').matches
        }
    },
    methods: {
        showModal() {
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        createNewCampaign() {
            this.form.post(route('campaigns.store'), {
                onFinish: () => {
                    this.form.reset();
                    this.closeModal()
                }
            });
        },
        generateCampaignCode() {
            // var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let randomChars = this.form.name.replace(/\s+/g, '');
            randomChars = randomChars.replace(/[^a-zA-Z ]/g, "");//remove special characters
            let randomNumbers = '0123456789';
            let result = 'RX';
            if (randomChars) {
                //pick a random number
                result += randomNumbers.charAt(Math.floor(Math.random() * randomNumbers.length));

                //pick 2 letters from the campaign name
                for (let i = 0; i < 2; i++) {
                    result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
                }
            }
            if (randomChars)
                return result.toUpperCase();
            else return '';
        },
        addDaysToCurrentDate(days) {
            let futureDate = new Date();
            futureDate.setDate(futureDate.getDate() + days);
            return futureDate;
        }
    },
    computed: {
        name() {
            return this.form.name;
        }
    },
    watch: {
        name: _.debounce(function () {
            this.form.code = this.generateCampaignCode();
        }, 1000),
        // name() {
        //     this.form.code = this.generateCampaignCode();
        // }
    }
}
</script>

<style scoped>
.dp__theme_dark {
    --dp-background-color: rgba(31, 41, 55, 1);
    --dp-text-color: #ffffff;
    --dp-hover-color: #484848;
    --dp-hover-text-color: #ffffff;
    --dp-hover-icon-color: #959595;
    --dp-primary-color: #005cb2;
    --dp-primary-text-color: #ffffff;
    --dp-secondary-color: #a9a9a9;
    --dp-border-color: rgba(55, 65, 81,1);
    --dp-menu-border-color: #2d2d2d;
    --dp-border-color-hover: #aaaeb7;
    --dp-disabled-color: #737373;
    --dp-scroll-bar-background: #212121;
    --dp-scroll-bar-color: #484848;
    --dp-success-color: #00701a;
    --dp-success-color-disabled: #428f59;
    --dp-icon-color: #959595;
    --dp-danger-color: #e53935;
}
</style>
